// <search-tabs> — All / Products / Help & pages filter on the search results page.
class SearchTabs extends HTMLElement {
  connectedCallback() {
    const tabs = [...this.querySelectorAll('[data-tab]')]; const secs = [...this.querySelectorAll('[data-sec]')];
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => { const on = x === t; x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on)); });
      secs.forEach((s) => { s.hidden = t.dataset.tab !== 'all' && s.dataset.sec !== t.dataset.tab; });
    }));
  }
}
if (!customElements.get('search-tabs')) customElements.define('search-tabs', SearchTabs);
